import { render, staticRenderFns } from "./MediumBanner.vue?vue&type=template&id=6768c512&"
import script from "./MediumBanner.vue?vue&type=script&lang=js&"
export * from "./MediumBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports